"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var _react = require("react");
var _hooks = require("../../hooks");
var _Icon = require("./Icon.styles");
var Icons = _interopRequireWildcard(require("./Svg"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Icon = props => {
  const {
    name,
    width = 24,
    height = 24,
    title
  } = props;
  const {
    getMeasurement
  } = (0, _hooks.useStylesUtils)();
  const styles = (0, _Icon.useStyles)(props);
  const [isHover, setIsHover] = (0, _react.useState)(false);
  const svgWidth = getMeasurement(width);
  const svgHeight = getMeasurement(height);
  const IconWrapper = Icons[name];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    width: svgWidth,
    height: svgHeight,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: `0 0 24 24`,
    className: styles['cc-Icon'],
    onMouseEnter: () => setIsHover(true),
    onMouseLeave: () => setIsHover(false),
    "aria-label": `${name} SVG`,
    children: [title && !isHover && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(IconWrapper, {})]
  });
};
exports.Icon = Icon;